import React, { Component } from "react";
import PageLayout from "../../components/PageLayout";
import Jumbotron from "../../components/Jumbotron";
import NavBar from "../../NavBar/NavBar";
import Alert from "../../components/Alert";
import { connect } from "react-redux";
import { initWorkflow } from "../../../redux/modules/workflow/actions";
import {
  generate,
  ROUTE_SITE_DASHBOARD,
  ROUTE_SITE_WORKFLOW,
} from "../../../redux/modules/route/routes";
import { pushRoute } from "../../../redux/modules/route/actions";
import { getWorkflowLogo } from "../../../redux/modules/workflow/strings";
import Throbber from "../../components/Throbber";
import { progressBarCenterContainerCN } from "./styles";

import type { WorkflowState } from "../../../redux/modules/workflow/reducer";
import { redirectGcpCreation } from "../../redirects/redirectGcpCreation";
import { AclState } from "../../../acl/reducer";
import { ensureAcl } from "../../../acl/asyncActions";

type WorkflowCreatePageProps = {
  // bound to dispatch in connect()
  dispatch: Function;
  aclState: AclState;
  workflowState: WorkflowState;

  // passed from Router
  customerId: string;
  siteId: string;
  workflowType: string;
};

class WorkflowCreatePage extends Component<WorkflowCreatePageProps> {
  async componentDidMount() {
    const { dispatch, customerId, siteId, workflowType } = this.props;

    if (workflowType === "gcp") {
      await dispatch(ensureAcl(customerId, siteId));
      const isPilot = this.props.aclState.systemLevel.includes(
        "BACKOFFICE_PILOT_INFO_VIEW",
      );
      return redirectGcpCreation(customerId, siteId, isPilot);
    }

    dispatch(initWorkflow(customerId, siteId, workflowType.toLowerCase())).then(
      ({ id }: { id: string }) => {
        dispatch(
          pushRoute(
            generate(ROUTE_SITE_WORKFLOW, {
              customerId,
              siteId,
              workflowType,
              workflowId: id,
              previous: ROUTE_SITE_DASHBOARD,
            }),
          ),
        );
      },
    );
  }

  render() {
    return (
      <PageLayout navBar={<NavBar />} header={this.renderHeader()}>
        {this.renderContent()}
      </PageLayout>
    );
  }

  renderHeader() {
    return (
      <Jumbotron
        header={""}
        imageUrl={getWorkflowLogo(this.props.workflowType.toUpperCase())}
      />
    );
  }

  renderContent() {
    const { errors, pending } = this.props.workflowState;

    if (errors && errors[0] != null) {
      return <Alert>{errors[0].message}</Alert>;
    }

    if (pending) {
      return (
        <div className={progressBarCenterContainerCN}>
          <Throbber />
        </div>
      );
    }

    return null;
  }
}

export default connect((state: any) => ({
  workflowState: state.workflows,
  aclState: state.acl as AclState,
}))(WorkflowCreatePage);
